import {FC} from "react";
import {Box, BoxProps} from "@mui/material";
import {makeStyles} from "tss-react/mui";

const useStyles = makeStyles()(() => ({
	container: {
		width: "40px",
		marginLeft: "24px",
		borderLeft: "1px solid #D8D8D8",
		position: "relative"
	},
	horizontalLine: {
		height: "1px",
		width: "40px",
		backgroundColor: "#D8D8D8",
		position: "absolute",
		top: "24px"
	}
}));

/** Mirrors shapeshift v1/comments/commentIndent */
export const CommentIndent: FC<BoxProps> = ({className, ...props}) => {
	const {classes, cx} = useStyles();
	return (
		<Box className={cx(classes.container, className)} {...props}>
			<div className={classes.horizontalLine} />
		</Box>
	);
};
